import React from 'react';
import styled from 'astroturf/react';

import type { ArmSpec } from '../armRegistry';
import { isDownloadRead } from '../openerIntent';
import type { OpenerDetail } from '../openerIntent';

const Strip = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xxs-8, 8px);
  margin-bottom: var(--spacing-xxs-8, 8px);
  font-family: var(--type-font-family-sans-serif, 'DM Sans', sans-serif);
  font-size: 14px;
  line-height: 1.4;
  color: var(--text-primary, #26262b);
`;

const Beat = styled.span`
  white-space: nowrap;
`;

const Arrow = styled.span`
  color: var(--text-tertiary, #9b9ba3);
`;

const INTENT_BEATS = ['Tap', 'Your PDF opens', 'Done'];
const GENERIC_BEATS = ['Tap', "You're in", 'Done'];

const AfterClickMap: React.FC<{ detail: OpenerDetail }> = ({ detail }) => {
  const beats = isDownloadRead(detail) ? INTENT_BEATS : GENERIC_BEATS;
  return (
    <Strip>
      {beats.map((label, index) => (
        <React.Fragment key={label}>
          {index > 0 && <Arrow aria-hidden="true">→</Arrow>}
          <Beat>{`${index + 1}. ${label}`}</Beat>
        </React.Fragment>
      ))}
    </Strip>
  );
};

export const afterClickMapSpec: ArmSpec = {
  slots: (ctx) => ({ preCta: <AfterClickMap detail={ctx.detail} /> }),
  stamp: (ctx) => ({
    render_state: isDownloadRead(ctx.detail) ? 'intent' : 'generic',
  }),
};
